class Utils {
  // Centralizza tutti i nomi di event custom usati nel tema
  // Permette di mantenere coerenza nei nomi degli eventi e facilita il refactoring
  // Pattern: E_<NAMESPACE>_<ACTION> (es. E_CART_ADDED, E_FORM_ERROR)
  // Ogni componente può ascoltare/emettere questi eventi tramite window.addEventListener/dispatchEvent

  static E_PASSWORDEYE_SHOWN = "password-eye:shown";
  static E_PASSWORDEYE_HIDDEN = "password-eye:hidden";

  static E_FORM_SUBMIT = "form:submit";
  static E_FORM_SUCCESS = "form:success";
  static E_FORM_ERROR = "form:error";
  static E_FORM_SENT = "form:sent";

  static E_SLIDER_CHANGE = "slider:change";

  static E_CART_ADDING = "cart:adding";
  static E_CART_ADDED = "cart:added";
  static E_CART_ERROR = "cart:error";
  static E_CART_REMOVED = "cart:removed";

  static E_COLLECTION_LOADED = "collection:loaded";
  static E_BLOG_LOADED = "blog:loaded";

  static E_QUANTITY_INPUT_CHANGED = "quantity:changed";

  static E_PLACES_CHANGED = "places:changed";
  static E_PLACES_GEOLOCATED = "places:geolocated";

  static E_MAP_BOUNDS_CHANGED = "map:bounds_changed";
  static E_STORE_SELECTED = "store:selected";
  static E_STORE_UNSELECTED = "store:unselected";

  static E_SEARCH_RESULT = "search:result";
  static E_PRODUCT_VIEW = "product:view";
  static E_PRODUCT_CLICK = "product:click";

  // Stile personalizzato per Google Maps che ridefinisce i colori del tema
  // Disabilita le icone dei POI e usa una palette minimalista
  static MAP_STYLE = [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#dadada"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c9c9c9"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ];
  
  static dateFromTime = (timestr) => {
    var date = new Date();
    const time = timestr.split(" ").at(-1).split("T").at(-1);
    date.setHours(time.split(":")[0] || 0);
    date.setMinutes(time.split(":")[1] || 0);
    date.setSeconds(time.split(":")[2] || 0);
    return date;
  }

  static getDateOfWeek = (wstr) => {
    const w = parseInt(wstr.split("W").at(-1));
    const y = parseInt(wstr.split("W").at(0));
    var d = (1 + (w - 1) * 7);
    return new Date(y, 0, d);
  }

  static errorHanlder = (error, title, description, button) => {
    console.error(error);
    Swal.fire({
      title: title || window.formErrors.generic,
      text: description,
      icon: 'error',
      confirmButtonText: button || window.formErrors.close,
      iconColor: 'var(--bs-danger)',
      color: 'var(--bs-body-color)',
      background: 'var(--bs-body-bg)',
      customClass: {
        title: 'fs-5',
        confirmButton: 'btn btn-primary'
      }
    })
  }

  static money = (amount) => {
    const a = parseFloat(amount/100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return window.currencyFormat.replace('{{amount}}', a).replace('{{amount_with_comma_separator}}', a);
  }

  static addTocart = (params) => {
    const data = params.data || new FormData(params.form);
    const url = window.Shopify.routes.root + 'cart/add.js';
    window.dispatchEvent(new CustomEvent(Utils.E_CART_ADDING, { detail: data.get('id') }));
    if(typeof params.before === 'function') {
      params.before(data.form);
    }
    axios.post(url, data)
      .then((response) => {
        try {
          const added = JSON.parse(response.request.responseText);
          window.dispatchEvent(new CustomEvent(Utils.E_CART_ADDED, { detail: added }));
          if(typeof params.success === 'function') {
            params.success(added);
          }
        } catch (e){
          window.dispatchEvent(new CustomEvent(Utils.E_CART_ERROR, { detail: e }));
          if(typeof params.error === 'function') {
            params.error(e);
          }
          Utils.errorHanlder(e);
        }
      })
      .catch((error) => {
        window.dispatchEvent(new CustomEvent(Utils.E_CART_ERROR, { detail: error }));
        Utils.errorHanlder(error, (error.response.data.description || error.message));
        if(typeof params.error === 'function') {
          params.error(error);
        }
      })
      .finally(() => {
        if(typeof params.finally === 'function') {
          params.finally();
        }
      });
  }

  static getDocument = (html) => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    return doc;
  }
}

class ThemeLoader extends HTMLElement {
  isGlobal = false;
  static classes = {
    active: 'd-flex',
    hidden: 'd-none',
  }
  
  constructor() {
    super();
    this.isGlobal = this.dataset.global !== undefined;

    if(this.isGlobal) {
      this.hide();
      window.onpageshow = () => {
        this.hide();
      }
      window.onpagehide = () => {
        this.show();
      }
    }
  }
  
  show = () => {
    this.classList.remove(ThemeLoader.classes.hidden);
    this.classList.add(ThemeLoader.classes.active);
  }

  hide = () => {
    this.classList.remove(ThemeLoader.classes.active);
    this.classList.add(ThemeLoader.classes.hidden);
  }
}
if (!window.customElements.get("theme-loader")) {
  window.customElements.define("theme-loader", ThemeLoader);
}

class ReadMore extends HTMLElement {
  expanded; expandible; link; text;
  static classes = {
    expanded: 'expanded',
    link: 'text-secondary text-decoration-underline'
  }

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.text = this.querySelector(':scope>div');
    this.expanded = false;
    this.expandible = this.text.scrollHeight > this.text.clientHeight;
    if(this.expandible){
      this.addLink();
    }
  }

  addLink = () => {
    this.link = document.createElement('a');
    this.link.setAttribute('href', '#');
    this.link.innerText = this.dataset.moreText;
    ReadMore.classes.link.split(' ').forEach(c => {
      this.link.classList.add(c);
    });
    this.link.addEventListener('click', (e) => {
      this.toggle(e);
    });
    this.appendChild(this.link);
  }

  toggle = (e) => {
    if(e != undefined)
      e.preventDefault();
    if(this.expanded)
      this.close();
    else
      this.open();
  }

  open = () => {
    this.classList.add(ReadMore.classes.expanded);
    this.link.innerText = this.dataset.lessText;
    this.expanded = true;
  }

  close = () => {
    this.classList.remove(ReadMore.classes.expanded);
    this.link.innerText = this.dataset.moreText;
    this.expanded = false;
  }
}
if (!window.customElements.get("read-more")) {
  window.customElements.define("read-more", ReadMore);
}